export const formatDate = (isoDate: string) => {
  var d = new Date(isoDate);
  
  return d.toLocaleDateString('pt-BR');
}

export const formatDateOnly = (value: unknown) => {
  if (!value) return value as string | undefined;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    const match = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (match) {
      const [, day, month, year] = match;
      return `${year}-${month}-${day}`;
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
    const parsed = new Date(trimmed);
    if (Number.isNaN(parsed.getTime())) return value;
    const year = parsed.getFullYear();
    const month = String(parsed.getMonth() + 1).padStart(2, '0');
    const day = String(parsed.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  if (value instanceof Date) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  return value as string;
}

/**
 * Normaliza um valor de data vindo da API para "date-only" (YYYY-MM-DD) sem sofrer shift de timezone.
 * Útil quando o backend devolve ISO datetime (ex.: 2025-01-01T00:00:00Z) mas o campo é apenas uma data.
 */
export const normalizeDateOnlyFromApi = (value: unknown): string | undefined => {
  if (!value) return undefined;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (/^\d{4}-\d{2}-\d{2}T/.test(trimmed)) return trimmed.slice(0, 10);
  }
  return formatDateOnly(value) as string | undefined;
};